import { LEARNING_HUB_ROUTE } from 'config'

// The course player has two parallel route trees:
//
//   * Learner: /learning-hub/course/:courseId/...
//     Gated by AuthorizedRoute + LayoutAuthorized; reads/writes attempt rows.
//
//   * Admin preview: /learning-hub/course-preview/course/:courseId/...
//     Stateless, authenticated by a per-course preview JWT. Mounted outside
//     the AuthorizedRoute so ActiveAdmin users (who have no portal session
//     token) can drive the same player components.
//
// The player components themselves are the same in both trees; they branch
// internal Links and API calls on `isPreview`. Keeping these path helpers in
// one place means Link targets stay consistent without each page having to
// remember which prefix to use.

const PREVIEW_PREFIX = `${LEARNING_HUB_ROUTE}/course-preview`
const LEARNER_PREFIX = LEARNING_HUB_ROUTE

function prefix(isPreview) {
  return isPreview ? PREVIEW_PREFIX : LEARNER_PREFIX
}

export function courseStoryPath(courseId, { isPreview = false } = {}) {
  return `${prefix(isPreview)}/course/${courseId}`
}

export function chapterOverviewPath(courseId, { isPreview = false } = {}) {
  return `${prefix(isPreview)}/course/${courseId}/chapters`
}

export function chapterBlockPath(
  courseId,
  chapterId,
  blockId,
  { isPreview = false } = {}
) {
  return `${prefix(
    isPreview
  )}/course/${courseId}/chapters/${chapterId}/blocks/${blockId}`
}

export function courseCompletionPath(courseId, { isPreview = false } = {}) {
  return `${prefix(isPreview)}/course/${courseId}/certificate`
}
